export default __webpack_public_path__ + "static/media/home.57a298e9.svg";